import { defineStore } from 'pinia'

export interface ModalState {
  id: string
  tabId: string
  state: boolean
  data?: Record<string, string | object | number | null>
  description: string
}

export interface Modals {
  items: ModalState[]
}
const STORE_NAME = 'modal'

export const useModalStore = defineStore(STORE_NAME, {
  state: (): Modals => ({ items: [] }),
  persist: false,
  actions: {
    addModal(modalId: string, tabId?: string, description: string = '') {
      const modalData = this.items.find((item: ModalState) => item.id === modalId)
      if (!modalData) {
        this.items.push({
          id: modalId,
          tabId: tabId ?? '',
          state: false,
          description
        })
      }
    },
    updateModal(modal: ModalState) {
      const existModalIndex: number = this.items.findIndex((item: ModalState) => item.id === modal.id)
      if (existModalIndex > -1) {
        this.items[existModalIndex] = modal
      }
    },
    removeModal(modalId: string) {
      this.items = this.items.filter((item: ModalState) => item.id !== modalId)
    },
    getModal(modalId: string): ModalState {
      const modalData: ModalState = { id: '', tabId: '', state: false, description: '' }
      return this.items.find((item: ModalState) => item.id === modalId) ?? modalData
    },
    reset() {
      this.items = []
    }
  }
})
